import _ from 'lodash'

import { loadingError, getNetworkMethods } from './network'
import { requestTranslation } from '@futures-platform/i18n'
import drupalApi from '@futures-platform/connectors/drupal-api'
import radarDataApi from '../radarDataApiProxy'
import { PUBLIC_URL } from '../env'
import * as actionTypes from '@futures-platform/reducers/actionTypes'
import {
    getRadarPhenomena, NEWSFEED_ERROR,
    NEWSFEED_ERROR_PARTIAL,
    storePhenomenonWithNewsFeeds
} from '@futures-platform/connectors/phenomena-api'
import { handleImageUploadIfNeeded } from '@futures-platform/connectors/media-api'
import { getPhenomenaTypes } from './phenomenaTypes'
import generatePPTX from '../pptx-generator'
import { ratingApi } from '../helpers/fetcher';

export const updateRadarVersion = version => ({
    type: actionTypes.UPDATE_RADAR_VERSION,
    payload: version
})

export function preloadImages (imageSources) {
    imageSources
        .forEach(i => {
        const linkEl = document.createElement('link');
        linkEl.setAttribute('rel', 'preload');
        linkEl.setAttribute('href', i);
        linkEl.setAttribute('as', 'image');
        document.head.appendChild(linkEl);
        });
    }

export const fetchRadar = (data = null) => async (dispatch, getState, ) => {
    const id = getState().radarSettings.id || 268659 // staging radar id
    const paramsString = document.location.search
    const searchParams = new URLSearchParams(paramsString)
    const isAIFCreatePreviewRadar = !searchParams.get('node') ? true : false
    
    const { loading, success, error } = getNetworkMethods(
        actionTypes.FETCH_RADAR,
        actionTypes.FETCH_RADAR_SUCCESS,
        requestTranslation('fetchingRadarError')
    )

    dispatch(loading())
    try {
        const radarData = !isAIFCreatePreviewRadar ? await drupalApi.getRadar(id) : 
        {
            "hideUsersFromTrial": false,
            "radarName": data?.radarName,
            "mapIntro": null,
            "radarLanguage": "en",
            "axisXTitle": null,
            "axisXMax": null,
            "axisXMin": null,
            "axisYTitle": null,
            "axisYMax": null,
            "axisYMin": null,
            "fourFieldsTopLeft": null,
            "fourFieldsTopRight": null,
            "fourFieldsBottomLeft": null,
            "fourFieldsBottomRight": null,
            "displayHaloWhenRating": null,
            "commentsOn": false,
            "likingOn": false,
            "ratingsOn": false,
            "votingOn": false,
            "discussionOn": false,
            "radarImage": "",
            "uuid": "55c01658-ebcf-4d92-a722-50cd445f1239",
            "signalToolEnabled": false,
            "ownerId": 1924,
            "enableUrlLogin": false,
            "isRadarTemplate": true,
            "titleLogo": null,
            "timelineLabelFormat": false,
            "id": 268659,
            "label": data?.radarName,
            "info_screen": null,
            "speech_bubble_flashing_time": null,
            "assign_new_users": false,
            "disable_newsfeed": false,
            "enable_public_share_url": false,
            "publicShareUrlEnabled": false,
            "enable_embedding": false,
            "url_login_count": null,
            "results_url": "https://go2.futuresplatform.com/node/268659/results",
            "url": "https://go2.futuresplatform.com/radar?node=268659",
            "group": [],
            "account": [],
            "phenomena": data?.phenomena || []
        }
        const img = new Image();
        img.onload = async () => {
            
        }
        preloadImages([`${PUBLIC_URL}${radarData?.radarImage}`])
        img.src = radarData?.radarImage // by setting an src, you trigger browser download
        
        let [phenomenaData, votingsData] = await Promise.all([
            !isAIFCreatePreviewRadar ? getRadarPhenomena(id, radarData?.group?.id) : {
                phenomena: data?.phenomena || [],
                radar_id: id,
                radar_version: 14,
                sectors : [
                    {
                        "id": 147527,
                        "version": 1,
                        "notes": "",
                        "title": "[sector name]"
                    }
                ],
                time_ranges : [
                    {
                        "id": 4683,
                        "version": 6,
                        "year": 2024,
                        "position": 0,
                        "label": "2019",
                        "title": "2019"
                    },
                    {
                        "id": 4684,
                        "version": 5,
                        "year": 2027,
                        "position": 0.42,
                        "label": "Inner circle",
                        "title": "Inner circle"
                    },
                    {
                        "id": 4685,
                        "version": 4,
                        "year": 2030,
                        "position": 0.75,
                        "label": "Mid circle",
                        "title": "Mid circle"
                    },
                    {
                        "id": 4686,
                        "version": 2,
                        "year": 2040,
                        "position": 1,
                        "label": "Outer circle",
                        "title": "Outer circle"
                    }
                ]
              },
            (!isAIFCreatePreviewRadar && !!radarData?.group?.id) ? ratingApi.getAllVotes(radarData?.group?.id, radarData?.id) : new Promise((resolve) => resolve([]))
          ])
          
          const {data: votingsObj} =  votingsData

            if (!isAIFCreatePreviewRadar) {
                Object.values(phenomenaData?.phenomena).forEach(res => {
                    // res.halo = _.get(radarData.phenomena[res.id], 'halo', false)
                    // eslint-disable-next-line
                    !!votingsObj && Object.keys(votingsObj).map(async (phe) => {
                        const pheURL = String(Object.keys(votingsObj[phe]));
                        const pheId = pheURL.split('/');
                    
                        if (votingsObj[phe][`/${pheId[1]}/radar/${pheId[3]}/phenomenon/${pheId[5]}`] && res?.id === pheId[5]) {
                            res['vote_sum'] = Number(votingsObj[phe]?.[`/${pheId[1]}/radar/${pheId[3]}/phenomenon/${pheId[5]}`]?.sum)
                        }
                        if(!!res['vote_sum'] && radarData?.displayHaloWhenRating <= res['vote_sum']) {
                            res.halo = true
                        } else {
                            res.halo = false
                        }
                      });
                    // res.halo = 
                    res.speech_bubble = _.get(radarData.phenomena[res.id], 'speech_bubble', false)
                })
            }

            const result = { ...radarData, ...phenomenaData }
            dispatch(getPhenomenaTypes(radarData.group.id)).then(() => dispatch(success(result)))
    } catch (err) {
        dispatch(error(err))
    }
}

export const refetchRadarData = () => async (dispatch, getState) => {
    const radarId = getState().radarSettings.id
    const groupId = getState().radarSettings.group.id

    const { loading, success, error } = getNetworkMethods(
        actionTypes.REFETCH_DATA,
        actionTypes.REFETCH_DATA_SUCCESS,
        requestTranslation('refetchingPhenomenaError')
    )

    dispatch(loading())

    try {
        const result = await getRadarPhenomena(radarId, groupId)

        dispatch(success(result))
    } catch (err) {
        dispatch(error(err))
    }
}

export const deleteRadarPhenomenon = (phenomenon, callback) => (dispatch, getState) => {
    const { time, version, id } = phenomenon
    const radarId = getState().radarSettings.id

    if (!time) {
        if (callback) {
            callback()
        }

        return dispatch({ type: actionTypes.DELETE_PHENOMENA_SUCCESS, payload: phenomenon })
    }

    const { loading, success, error } = getNetworkMethods(
        actionTypes.DELETE_PHENOMENA,
        actionTypes.DELETE_PHENOMENA_SUCCESS,
        requestTranslation('deletingPhenomenaError')
    )

    dispatch(loading())

    const data = {
        version,
        phenomenon_uuid: id
    }

    return radarDataApi.deletePhenomenon(radarId, data)
        .then(() => {
            dispatch(success(phenomenon))
            if (callback) {
                callback()
            }
        })
        .catch(err => dispatch(error(err)))
}

export const updatePhenomenonPosition = phenomenon => ({
    type: actionTypes.UPDATE_PHENOMENON,
    payload: phenomenon
})

export const updatePhenomenonVersion = phenomenon => ({
    type: actionTypes.UPDATE_PHENOMENON_VERSION,
    payload: phenomenon
})

const phenomenaApiErrorHandler = (error, errorFunc, dispatch) => {
    switch (error.response.data.error_code) {
        case 'outdated-version':
            dispatch(errorFunc(new Error('Outdated version'), requestTranslation('outDatedVersionError')))
            break
        case 'resource-not-found':
            dispatch(errorFunc(new Error('Not found'), requestTranslation('phenomenaNotFound')))
            break
        case 'already-exists':
            dispatch(errorFunc(new Error('Already exists'), requestTranslation('phenomenaExists')))
            break
        case 'invalid-input':
            dispatch(errorFunc(new Error('Invalid input'), requestTranslation('phenomenaInvalid')))
            break
        default:
            dispatch(errorFunc(error))
            break
    }
}

export const updateStoredPhenonSelector = payload => dispatch =>
    dispatch({ type: 'STOREDPHENOMENON', payload: payload })

export const storePhenomenon = (phenomenon, newsFeedChanges, callback, archived = false) => async (dispatch) => {
    let {
        group,
        _upload: {
            imageFile,
            imageUrl,
            // image // Contains image data url
          } = {},
        ...rest
    } = phenomenon

    const { loading, success, error } = phenomenon.id
        ? getNetworkMethods(
            actionTypes.UPDATE_PHENOMENON_INGESTION,
            actionTypes.UPDATE_PHENOMENON_INGESTION_SUCCESS,
            requestTranslation('updatingPhenomenaError')
        ) : getNetworkMethods(
            actionTypes.CREATE_PHENOMENA,
            actionTypes.CREATE_PHENOMENA_SUCCESS,
            requestTranslation('creatingPhenomenaError')
        )

    dispatch(loading())

    const phenomenonInput = {
        ...rest,
        archived,
        group,
    }

    phenomenonInput.content.media.image = await handleImageUploadIfNeeded(imageFile || imageUrl, group) || ''


    try {
        if(!phenomenonInput?.group || phenomenonInput?.group === undefined ) {
            // eslint-disable-next-line no-restricted-globals
            // phenomenonInput.group = phenomenonInput?.groups[0] ?? 0
            phenomenonInput.group = (!!phenomenonInput?.groups?.length && !!phenomenonInput?.groups[0]) ? phenomenonInput?.groups[0] : 0
        }
        const { storedPhenomenon, status, failedNewsFeedTitles } = await storePhenomenonWithNewsFeeds(phenomenonInput, newsFeedChanges)

        if (status === NEWSFEED_ERROR_PARTIAL) {
            dispatch(error(new Error('News feed error'), requestTranslation('someNewsFeedCreationError', failedNewsFeedTitles)))
        } else if (status === NEWSFEED_ERROR) {
            dispatch(error(new Error('News feed error'), requestTranslation(phenomenon.id ? 'newsFeedUpdateError' : 'newsFeedCreationError')))
        } else {
            dispatch({ type: 'STOREDPHENOMENON', payload: storedPhenomenon })
            dispatch(success(storedPhenomenon))
            
            callback(storedPhenomenon)
        }
    } catch (e) {
        dispatch(error(e))
    }
}

export const updatePhenomenon = (phenomenon, positionData) => (dispatch, getState) => {
    dispatch(updatePhenomenonPosition({ ...phenomenon, ...positionData }))

    const radarId = getState().radarSettings.id
    const { id } = phenomenon
    const updatedPhenomenon = _.find(getState().phenomena, { id })

    const { loading, success, error } = getNetworkMethods(
        actionTypes.UPDATE_PHENOMENON_ASYNC,
        actionTypes.UPDATE_PHENOMENON_ASYNC_SUCCESS,
        requestTranslation('updatingPhenomenaError')
    )

    const { sectorId, time, xOffset, version } = updatedPhenomenon

    const data = {
        sectorId,
        time,
        xOffset,
        id,
        version
    }

    dispatch(loading())

    return radarDataApi.updatePhenomenon(radarId, data)
        .then(response => {
            dispatch(updatePhenomenonVersion(response.phenomenon))

            dispatch(success())
        })
        .catch(err => {
            phenomenaApiErrorHandler(err, error, dispatch)

            return dispatch(refetchRadarData())
        })
}

export const createPhenomenonWithPosition = (phenomenon, positionData) => (dispatch, getState) => {
    dispatch(updatePhenomenonPosition({ ...phenomenon, ...positionData }))

    const { id } = phenomenon

    const updatedPhenomenon = _.find(getState().phenomena, { id })

    const { loading, success, error } = getNetworkMethods(
        actionTypes.CREATE_PHENOMENA_POSITION,
        actionTypes.CREATE_PHENOMENA_POSITION_SUCCESS,
        requestTranslation('settingPhenomenaError')
    )

    const radarId = getState().radarSettings.id

    const { sectorId, time, xOffset } = updatedPhenomenon

    dispatch(loading())

    const data = {
        radarId,
        id,
        sectorId,
        time,
        xOffset
    }

    radarDataApi.createPhenomenon(Number(radarId), data)
        .then(resultData => dispatch(success(resultData.phenomenon)))
        .catch(err => {
            phenomenaApiErrorHandler(err, error, dispatch)

            return dispatch(refetchRadarData())
        })
}

export const setDraggedPhenomenon = id => dispatch =>
    dispatch({ type: actionTypes.SET_DRAGGED_PHENOMENON, payload: id })


export const cloneRadar = callback => (dispatch, getState) => {
    const { loading, success, error } = getNetworkMethods(
        actionTypes.CLONE_RADAR,
        actionTypes.CLONE_RADAR_SUCCESS,
        requestTranslation('cloningRadarError')
    )

    const parentRadarId = getState().radarSettings.id

    dispatch(loading())

    drupalApi.cloneRadar(parentRadarId)
        .then(radarData => {
            dispatch(success(radarData))
            callback(`${PUBLIC_URL}/radar?node=${radarData.id}`)
        })
        .catch(err => {
            if (err && err.response && err.response.status === 400) {
                dispatch(loadingError(
                    actionTypes.CLONE_RADAR,
                    err,
                    '',
                    requestTranslation('licenseError'))
                )
            } else {
                dispatch(error(err))
            }
        })
}

export const deleteRadar = () => (dispatch, getState) => {
    const { loading, success, error } = getNetworkMethods(
        actionTypes.DELETING_RADAR,
        actionTypes.DELETING_RADAR_SUCCESS,
        requestTranslation('deletingRadarError')
    )

    dispatch(loading())

    return drupalApi.deleteRadar(getState().radarSettings.id)
        .then(() => {
            dispatch(success())
            document.location.href = '/'
        })
        .catch(err => dispatch(error(err)))
}

export const addPublicPhenomenaToRadar = (phenomenon, callback) => (dispatch, getState) => {
    const { id } = phenomenon

    dispatch({
        type: actionTypes.CREATE_PHENOMENA_SUCCESS,
        payload: phenomenon
    })

    callback(_.find(getState().phenomena, { id }))
}

export const generatePowerpoint = (id, groupId) => async (dispatch, getState) => {
    const { loading, success, error } = getNetworkMethods(
        actionTypes.GENERATE_POWERPOINT,
        actionTypes.GENERATE_POWERPOINT_SUCCESS,
        requestTranslation('generatingPPTXError')
    )

    dispatch(loading())
    
    const isFlipAxis = await ratingApi.getFlipAxisAfterSaved(groupId, id)
    const isFlipFlag = isFlipAxis?.data?.isFlip || false
    return generatePPTX(id, groupId, isFlipFlag)
        .then(() => dispatch(success()))
        .catch(err => dispatch(error(err)))
}